export { InMemoryCache, defaultDataIdFromObject } from './inMemoryCache';
export * from './readFromStore';
export * from './writeToStore';
export * from './fragmentMatcher';
export * from './objectCache';
export * from './recordingCache';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-cache-inmemory/lib/index.js
// module id = 1427
// module chunks = 0